import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle"]

  toggle() {
    const btn = this.toggleTarget
    const isActive = btn.classList.toggle("settings__toggle--active")
    const url = btn.dataset.url
    const field = btn.dataset.field

    // private account = NOT public_profile
    const value = !isActive

    const formData = new FormData()
    formData.append(field, value)

    fetch(url, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      },
      body: formData
    })
  }
}
